// frontend/src/utils/handbookProgress.js
// Per-device persistence of coach handbook checklist progress via localStorage.
const KEY_PREFIX = "coachHandbook.progress.";

const buildKey = (chapterSlug, itemKey) =>
  `${KEY_PREFIX}${chapterSlug}.${itemKey}`;

export const getItemState = (chapterSlug, itemKey) => {
  try {
    return localStorage.getItem(buildKey(chapterSlug, itemKey)) === "1";
  } catch {
    return false;
  }
};

export const setItemState = (chapterSlug, itemKey, completed) => {
  try {
    const k = buildKey(chapterSlug, itemKey);
    if (completed) {
      localStorage.setItem(k, "1");
    } else {
      localStorage.removeItem(k);
    }
  } catch {
    // ignore — storage may be full or disabled
  }
};

export const getChapterProgress = (chapterSlug, checklists) => {
  if (!Array.isArray(checklists)) return { done: 0, total: 0 };
  let done = 0;
  let total = 0;
  for (const cl of checklists) {
    if (!Array.isArray(cl.items)) continue;
    for (const item of cl.items) {
      total += 1;
      if (getItemState(chapterSlug, item.key)) done += 1;
    }
  }
  return { done, total };
};

export const resetChapter = (chapterSlug, checklists) => {
  if (!Array.isArray(checklists)) return;
  for (const cl of checklists) {
    if (!Array.isArray(cl.items)) continue;
    for (const item of cl.items) {
      try {
        localStorage.removeItem(buildKey(chapterSlug, item.key));
      } catch {
        // ignore
      }
    }
  }
};
